/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getExchangeData} from '../api'

 export const useQueryGetExchangeData = createReactQueryHook('getExchangeData', getExchangeData)
